import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "react-simple-snackbar";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  DialogActions,
  Card,
  CardContent,
  CardActions,
  CardHeader,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  settingsContainer: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    border: "1px solid #ccc",
    borderRadius: theme.shape.borderRadius,
  },
  dialogTitle: {
    backgroundColor: "#ef7f1a",
    color: "#fff",
  },
  card: {
    width: "300px",
    padding: "16px",
    fontWeight: "normal",
    fontSize: "16px",
    margin: "0.5rem",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  button: {
    marginTop: "16px",
  },
  section: {
    marginBottom: "8px",
  },
  sectionTitle: {
    fontWeight: "bold",
    marginRight: "8px",
  },
  sectionValue: {
    color: "#333",
  },
}));

const PRINT_COUNT_KEY = "invoicePrintCount";

const PrintSettings = () => {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [printCount, setPrintCount] = useState(() => {
    return localStorage.getItem(PRINT_COUNT_KEY) || "DOUBLE";
  });
  const [tempPrintCount, setTempPrintCount] = useState(printCount);
  const [openSnackbar] = useSnackbar();

  const handleOpen = () => {
    setTempPrintCount(printCount);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSave = () => {
    setPrintCount(tempPrintCount);
    localStorage.setItem(PRINT_COUNT_KEY, tempPrintCount);
    openSnackbar("Print settings saved");
    setOpenDialog(false);
  };

  const handleCancel = () => {
    setTempPrintCount(printCount);
    setOpenDialog(false);
  };

  return (
    <div>
      <Card className={classes.card} elevation={3}>
        <CardHeader
          title={<Typography variant="h6">Print Settings</Typography>}
        />
        <CardContent className={classes.cardContent}>
          <div className={classes.section}>
            <Typography variant="subtitle1" className={classes.sectionTitle}>
              Invoice Print Count:
            </Typography>
            <Typography variant="body1" className={classes.sectionValue}>
              {printCount === "SINGLE" ? "Single (1 copy)" : "Double (2 copies)"}
            </Typography>
          </div>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpen}
            className={classes.button}
          >
            Edit
          </Button>
        </CardActions>
      </Card>

      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="h6">Print Settings</Typography>
        </DialogTitle>
        <DialogContent>
          <div className={classes.settingsContainer}>
            <Typography variant="subtitle1">Invoice Print Count</Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
              Select how many copies to print for each invoice
            </Typography>
            <RadioGroup
              aria-label="print-count"
              name="print-count"
              value={tempPrintCount}
              onChange={(e) => setTempPrintCount(e.target.value)}
            >
              <FormControlLabel
                value="SINGLE"
                control={<Radio style={{ color: "#ef7f1a" }} />}
                label="Single (1 copy)"
              />
              <FormControlLabel
                value="DOUBLE"
                control={<Radio style={{ color: "#ef7f1a" }} />}
                label="Double (2 copies)"
              />
            </RadioGroup>
          </div>
        </DialogContent>
        <DialogActions style={{ display: "flex" }}>
          <Button
            variant="contained"
            style={{ backgroundColor: "#ef7f1a", color: "white" }}
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "#ef7f1a" }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PrintSettings;
